// extracted by mini-css-extract-plugin
export default {"finishSetup":"_ivehio","header":"_1mo2wjr","appCard":"_go6btj","column":"_1kgk45s","addToSite":"_mv1k6h","manageAppsLink":"_25jgej"};